const translations = {
  'Plans and payment method': {
    en: 'Plans and payment method',
    es: 'Planes y método de pago',
    pt: 'Planos e método de pagamento'
  },
  'Personal information': {
    en: 'Personal information',
    es: 'Datos personales',
    pt: 'Informações pessoais'
  },
  'Change password': {
    en: 'Change password',
    es: 'Cambiar contraseña',
    pt: 'Alterar senha'
  },
  'Delete account': {
    en: 'Delete account',
    es: 'Eliminar cuenta',
    pt: 'Excluir conta'
  },
  'Preferences': {
    en: 'Preferences',
    es: 'Preferencias',
    pt: 'Preferências'
  },
  'Site language': {
    en: 'Site language',
    es: 'Idioma del sitio',
    pt: 'Idioma do site'
  },
  'Hide scores': {
    en: 'Hide scores',
    es: 'Ocultar resultados',
    pt: 'Ocultar resultados'
  },
  'Show scores': {
    en: 'Show scores',
    es: 'Mostrar resultados',
    pt: 'Mostrar resultados'
  },
  'Support': {
    en: 'Support',
    es: 'Soporte',
    pt: 'Suporte'
  },
  'Help center': {
    en: 'Help center',
    es: 'Centro de ayuda',
    pt: 'Central de ajuda'
  },
  'Need help with your account?': {
    en: 'Need help with your account?',
    es: '¿Necesitas ayuda con tu cuenta?',
    pt: 'Precisa de ajuda com sua conta?'
  },
  'Go to help center': {
    en: 'Go to help center',
    es: 'Ir al centro de ayuda',
    pt: 'Ir para o centro de ajuda'
  },
  'Save changes': {
    en: 'Save changes',
    es: 'Guardar cambios',
    pt: 'Salvar alterações'
  },
  'Current password': {
    en: 'Current password',
    es: 'Contraseña actual',
    pt: 'Senha atual'
  },
  'Confirm new password': {
    en: 'Confirm new password',
    es: 'Confirmar nueva contraseña',
    pt: 'Confirmar nova senha'
  },
  'You are about to start the process of deleting your account. Your account will be deleted within 30 days of the request.': {
    en: 'You are about to start the process of deleting your account. Your account will be deleted within 30 days of the request.',
    es: 'Estás a punto de iniciar el proceso de eliminación de tu cuenta. Tu cuenta se eliminará en un plazo de 30 días a partir de la solicitud.',
    pt: 'Você está prestes a iniciar o processo de exclusão de sua conta. Sua conta será excluída em até 30 dias após a solicitação.'
  },
  'You have active plans': {
    en: 'You have active plans',
    es: 'Tienes planes activos',
    pt: 'Você tem planos ativos',
  },
  'There are plans that require renewal, in order to delete your account, you must first cancel these plans.': {
    en: 'There are plans that require renewal, in order to delete your account, you must first cancel these plans.',
    es: 'Hay planes que requieren renovación, para eliminar tu cuenta, primero debes cancelar estos planes.',
    pt: 'Há planos que exigem renovação. Para excluir sua conta, você deve primeiro cancelar esses planos.',
  },
  'View plans': {
    en: 'View plans',
    es: 'Ver planes',
    pt: 'Veja planos'
  },
  'English': {
    en: 'English',
    es: 'Inglés',
    pt: 'Inglês',
  },
  'Spanish': {
    en: 'Spanish',
    es: 'Español',
    pt: 'Espanhol',
  },
  'Portuguese': {
    en: 'Portuguese',
    es: 'Portugués',
    pt: 'Português',
  },
  'for all matches. You can change this settings at any time.': {
    en: 'for all matches. You can change this settings at any time.',
    es: 'de todos los partidos. Puedes cambiar esta configuración en cualquier momento.',
    pt: 'de todas as partidas. Você pode alterar essa configuração a qualquer momento.'
  },
  'Are you sure you want to hide scores for all matches?': {
    en: 'Are you sure you want to hide scores for all matches?',
    es: '¿Estás seguro de que quieres ocultar resultados de todos los partidos?',
    pt: 'Você tem certeza que quer ocultar resultados de todas as partidas?'
  },
  'Confirm': {
    en: 'Confirm',
    es: 'Confirmar',
    pt: 'Confirme',
  },
  'What is Fanatiz?': {
    en: 'What is Fanatiz?',
    es: '¿Qué es Fanatiz?',
    pt: 'O que é Fanatiz?'
  },
  'On which devices can I stream Fanatiz?': {
    en: 'On which devices can I stream Fanatiz?',
    es: '¿En qué dispositivos puedo transmitir Fanatiz?',
    pt: 'Em quais dispositivos posso transmitir o Fanatiz?'
  },
  'What is included in a paid plan?': {
    en: 'What is included in a paid plan?',
    es: '¿Qué incluye un plan de pago?',
    pt: 'O que está incluso em um plano pago?'
  },
  'Do you offer Pay Per View (PPV)? What does it include?': {
    en: 'Do you offer Pay Per View (PPV)? What does it include?',
    es: '¿Ofrecen Pay Per View (PPV)? ¿Qué incluye?',
    pt: 'Você oferece Pay Per View (PPV)? O que inclui?'
  },
  'Fanatiz is a leading sports streaming platform targeting primarily, but not exclusively, Latinamerican audiences in their language and in english. Fanatiz offers fans and viewers the ability to watch matches live or on demand (VOD) from the sports networks and leagues that they are most passionate about. All 100% legal and secure, on HD quality, with just a stable internet connection in most devices like web, mobile or CTV.': {
    en: 'Fanatiz is a leading sports streaming platform targeting primarily, but not exclusively, Latinamerican audiences in their language and in english. Fanatiz offers fans and viewers the ability to watch matches live or on demand (VOD) from the sports networks and leagues that they are most passionate about. All 100% legal and secure, on HD quality, with just a stable internet connection in most devices like web, mobile or CTV.',
    es: 'Fanatiz es una plataforma líder de transmisión de deportes dirigida principalmente, pero no exclusivamente, a audiencias latinoamericanas en su idioma y en inglés. Fanatiz ofrece a los fanáticos y televidentes la posibilidad de ver partidos en vivo o bajo demanda (VOD) de las cadenas y ligas deportivas que más les apasionan. Todo 100% legal y seguro, en calidad HD, con solo una conexión a Internet estable en la mayoría de los dispositivos como web, móvil o CTV.',
    pt: 'A Fanatiz é uma plataforma líder de streaming esportivo voltada principalmente, mas não exclusivamente, para o público latino-americano em seu idioma e em inglês. Fanatiz oferece aos fãs e telespectadores a possibilidade de assistir a partidas ao vivo ou sob demanda (VOD) dos canais esportivos e ligas pelas quais eles e elas são mais apaixonados. Tudo 100% legal e seguro, em qualidade HD, com apenas uma conexão de internet estável na maioria dos dispositivos como web, celular ou CTV.'
  },
  'Fanatiz is available on most devices with an internet connection including smart TVs, streaming sticks, smartphones, tablets and computers. This are: iPhone, iPad, Androird smartphones and tablets, Amazon Fire TV and stick, Android TV, Apple TV, Hisense TV, Google Chromecast, Airplay, PC and Mac with any web browser.': {
    en: 'Fanatiz is available on most devices with an internet connection including smart TVs, streaming sticks, smartphones, tablets and computers. This are: iPhone, iPad, Androird smartphones and tablets, Amazon Fire TV and stick, Android TV, Apple TV, Hisense TV, Google Chromecast, Airplay, PC and Mac with any web browser.',
    es: 'Fanatiz está disponible en la mayoría de los dispositivos con conexión a Internet, incluidos televisores inteligentes, dispositivos de transmisión, teléfonos inteligentes, tabletas y computadoras. Estos son: iPhone, iPad, smartphones y tabletas Androird, Amazon Fire TV y stick, Android TV, Apple TV, Hisense TV, Google Chromecast, Airplay, PC y Mac con cualquier navegador web.',
    pt: 'O Fanatiz está disponível na maioria dos dispositivos com conexão à internet, incluindo smart TVs, streaming sticks, smartphones, tablets e computadores. São eles: iPhone, iPad, smartphones e tablets Androird, Amazon Fire TV e stick, Android TV, Apple TV, Hisense TV, Google Chromecast, Airplay, PC e Mac com qualquer navegador da web.'
  },
  'All plans include the persoanlization of your experience by selecting your teams of interest and have access to live stats and resultas. Depending on the plan you choose you may have access to premium live sports content either on well known channels or as stand alone events, in various languages and with their VOD for re-wacth. Also you may access special content in VOD such as documentaries, highlights, summaries, interviews, stats and more.': {
    en: 'All plans include the persoanlization of your experience by selecting your teams of interest and have access to live stats and resultas. Depending on the plan you choose you may have access to premium live sports content either on well known channels or as stand alone events, in various languages and with their VOD for re-wacth. Also you may access special content in VOD such as documentaries, highlights, summaries, interviews, stats and more.',
    es: 'Todos los planes incluyen la personalización de tu experiencia al seleccionar tus equipos de interés y tener acceso a estadísticas y resultados en vivo. Según el plan que elijas, puedes tener acceso a contenido deportivo premium en vivo, ya sea en canales conocidos o como eventos independientes, en varios idiomas y con su VOD para volver a verlo. También puedes acceder a contenido especial en VOD como documentales, destacados, resúmenes, entrevistas, estadísticas y más.',
    pt: 'Todos os planos incluem a personalização da sua experiência selecionando os suos times de interesse e tendo acesso a estatísticas e resultados ao vivo. Dependendo do plano que você escolher, você pode ter acesso a conteúdo premium de esportes ao vivo em canais conhecidos ou como eventos independentes, em vários idiomas e com VOD para re-wacth. Além disso, você pode acessar conteúdos especiais em VOD, como documentários, destaques, resumos, entrevistas, estatísticas e muito mais.'
  },
  'Fanatiz offers PPV of different sports events on a regular basis. It varies per content but you may access the live event, special VOD content and the VOD of the event for re-watch. Please always check the details of each PPV.': {
    en: 'Fanatiz offers PPV of different sports events on a regular basis. It varies per content but you may access the live event, special VOD content and the VOD of the event for re-watch. Please always check the details of each PPV.',
    es: 'Fanatiz ofrece PPV de diferentes eventos deportivos regularmente. Varía según el contenido, pero puedes acceder al evento en vivo, al contenido VOD especial y al VOD del evento para volver a verlo. Por favor, consulta siempre los detalles de cada PPV.',
    pt: 'A Fanatiz oferece PPV de diferentes eventos esportivos regularmente. Varia de acordo com o conteúdo, mas você pode acessar o evento ao vivo, o conteúdo especial de VOD e o VOD do evento para assistir novamente. Por favor, verifique sempre os detalhes de cada PPV.'
  },
  "Didn't find what you were looking for?": {
    en: "Didn't find what you were looking for?",
    es: '¿No encontraste lo que buscabas?',
    pt: 'Não encontrou o que estava procurando?'
  },
  'Status': {
    en: 'Status',
    es: 'Estado',
    pt: 'Estado'
  },
  'Devices': {
    en: 'Devices',
    es: 'Dispositivos',
    pt: 'Dispositivos'
  },
  'Mobile': {
    en: 'Mobile',
    es: 'Móvil',
    pt: 'Celular'
  },
  'Tablet': {
    en: 'Tablet',
    es: 'Tablet',
    pt: 'Tablet'
  },
  'TV': {
    en: 'TV',
    es: 'TV',
    pt: 'TV'
  },
  'Renewal': {
    en: 'Renewal',
    es: 'Renovación',
    pt: 'Renovação'
  },
  'Price': {
    en: 'Price',
    es: 'Precio',
    pt: 'Preço'
  },
  'Manage plan': {
    en: 'Manage plan',
    es: 'Administrar plan',
    pt: 'Gerenciar plano'
  },
  'Add plan': {
    en: 'Add plan',
    es: 'Agregar plan',
    pt: 'Adicionar plano'
  },
  'Edit card': {
    en: 'Edit card',
    es: 'Editar tarjeta',
    pt: 'Editar cartão'
  },
  'First name': {
    en: 'First name',
    es: 'Nombre',
    pt: 'Nome'
  },
  'Address': {
    en: 'Address',
    es: 'Dirección',
    pt: 'Endereço'
  },
  'Address 2': {
    en: 'Address 2',
    es: 'Dirección 2',
    pt: 'Endereço 2'
  },
  'Complete your profile': {
    en: 'Complete your profile',
    es: 'Completa tu perfil',
    pt: 'Complete seu perfil'
  },
  'Add your mobile number so we can reach you about your subscription.': {
    en: 'Add your mobile number so we can reach you about your subscription.',
    es: 'Agrega tu número de celular para que podamos contactarte sobre tu suscripción.',
    pt: 'Adicione seu número de celular para que possamos falar com você sobre sua assinatura.'
  },
  'Complete': {
    en: 'Complete',
    es: 'Completar',
    pt: 'Completar'
  },
  'Profile incomplete': {
    en: 'Profile incomplete',
    es: 'Perfil incompleto',
    pt: 'Perfil incompleto'
  },
  'Mobile number': {
    en: 'Mobile number',
    es: 'Número de celular',
    pt: 'Número de celular'
  },
  'Invalid mobile number': {
    en: 'Invalid mobile number',
    es: 'Número de celular inválido',
    pt: 'Número de celular inválido'
  },
  'Your mobile number cannot be removed, only replaced': {
    en: 'Your mobile number cannot be removed, only replaced',
    es: 'Tu número de celular no se puede eliminar, solo reemplazar',
    pt: 'Seu número de celular não pode ser removido, apenas substituído'
  },
  'Country code': {
    en: 'Country code',
    es: 'Código de país',
    pt: 'Código do país'
  },
  'Country': {
    en: 'Country',
    es: 'País',
    pt: 'País'
  },
  'City': {
    en: 'City',
    es: 'Ciudad',
    pt: 'Cidade'
  },
  'Postal code': {
    en: 'Postal code',
    es: 'Código postal',
    pt: 'CEP'
  },
  'Credit card information': {
    en: 'Credit card information',
    es: 'Información de la tarjeta de crédito',
    pt: 'Informações do cartão de crédito'
  },
  'Card number': {
    en: 'Card number',
    es: 'Número de tarjeta',
    pt: 'Número de cartão'
  },
  'Expire date': {
    en: 'Expire date',
    es: 'Fecha de exp.',
    pt: 'Data de expiração',
  },
  Cancel: {
    en: 'Cancel',
    es: 'Cancelar',
    pt: 'Cancelar'
  },
  'Edit payment method': {
    en: 'Edit payment method',
    es: 'Editar método de pago',
    pt: 'Editar método de pagamento',
  },
  'Manage your subscription': {
    en: 'Manage your subscription',
    es: 'Administra tu suscripción',
    pt: 'Gerenciar sua assinatura'
  },
  'Current plan': {
    en: 'Current plan',
    es: 'Plan actual',
    pt: 'Plano atual'
  },
  'Payment method': {
    en: 'Payment method',
    es: 'Método de pago',
    pt: 'Meio de Pagamento'
  },
  'Change plan': {
    en: 'Change plan',
    es: 'Cambiar plan',
    pt: 'Alterar plano'
  },
  'See more plan details': {
    en: 'See more plan details',
    es: 'Ver mas detalles del plan',
    pt: 'Veja mais detalhes do plano',
  },
  'Promotional code': {
    en: 'Promotional Code',
    es: 'Código Promocional',
    pt: 'Código Promocional'
  },
  'Special promo': {
    en: 'Special promo',
    es: 'Promo especial',
    pt: 'Promoção especial'
  },
  'Do you have a promotional code?': {
    en: 'Do you have a promotional code?',
    es: '¿Tienes un código promocional?',
    pt: 'Você tem um código de desconto?'
  },
  'Add code': {
    en: 'Add code',
    es: 'Agregar código',
    pt: 'Adicionar código'
  },
  'Add code +': {
    en: 'Add code +',
    es: 'Agregar código +',
    pt: 'Adicionar código +'
  },
  'Change code': {
    en: 'Change code',
    es: 'Cambiar código',
    pt: 'Alterar código'
  },
  'Add promotional code': {
    en: 'Add promotional code',
    es: 'Agregar código promocional',
    pt: 'Adicionar código promocional',
  },
  'Change promotional code': {
    en: 'Change promotional code',
    es: 'Cambiar código promocional',
    pt: 'Alterar código promocional',
  },
  'Enter your promotional code to apply discounts': {
    en: 'Enter your promotional code to apply discounts',
    es: 'Introduce tu código promocional para aplicar descuentos',
    pt: 'Digite seu código promocional para aplicar descontos'
  },
  'Enter your promotional code': {
    en: 'Enter your promotional code',
    es: 'Introduce tu código promocional',
    pt: 'Digite seu código de desconto'
  },
  'Discount': {
    en: 'Discount',
    es: 'Descuento',
    pt: 'Desconto'
  },
  'Product price': {
    en: 'Product price',
    es: 'Precio del producto',
    pt: 'Preço do produto'
  },
  'Final price': {
    en: 'Final price',
    es: 'Precio final',
    pt: 'Preço final'
  },
  'Cancel subscription': {
    en: 'Cancel subscription',
    es: 'Cancelar suscripción',
    pt: 'Cancelar assinatura'
  },
  'Pause subscription': {
    en: 'Pause subscription',
    es: 'Pausar suscripción',
    pt: 'Pausar assinatura'
  },
  'Pause your subscription': {
    en: 'Pause your subscription',
    es: 'Pausar tu suscripción',
    pt: 'Pausar sua assinatura'
  },
  'Before you continue, can you share with us your main reason for canceling the service?': {
    en: 'Before you continue, can you share with us your main reason for canceling the service?',
    es: 'Antes de continuar, ¿puedes compartir con nosotros tu razón principal para cancelar el servicio?',
    pt: 'Antes de continuar, você pode compartilhar conosco seu principal motivo para cancelar o serviço?'
  },
  'Keep my plan': {
    en: 'Keep my plan',
    es: 'Mantener mi plan',
    pt: 'Manter meu plano'
  },
  'More details (optional)': {
    en: 'More details (optional)',
    es: 'Más detalles (opcional)',
    pt: 'Mais detalhes (opcional)'
  },
  'There was an error while trying to reactivate subscription': {
    en: 'There was an error while trying to reactivate subscription',
    es: 'Hubo un error al intentar reactivar la suscripción',
    pt: 'Ocorreu um erro ao tentar reativar a assinatura',
  },
  'There was an error while trying to cancel subscription': {
    en: 'There was an error while trying to cancel subscription',
    es: 'Hubo un error al intentar cancelar la suscripción',
    pt: 'Ocorreu um erro ao tentar cancelar a assinatura',
  },
  'An error has occurred while pausing the subscription.': {
    en: 'An error has occurred while pausing the subscription.',
    es: 'Ocurrió un error al pausar la suscripción.',
    pt: 'Ocorreu um erro ao pausar a assinatura.',
  },
  'Subscription paused': {
    en: 'Subscription paused',
    es: 'Suscripción pausada',
    pt: 'Assinatura pausada',
  },
  'Your subscription has been paused. Any credit you may have will be executed after the end of this period, see you soon!': {
    en: 'Your subscription has been paused. Any credit you may have will be executed after the end of this period, see you soon!',
    es: 'Tu suscripción ha sido pausada. Cualquier crédito que puedas tener se ejecutará después del final de este período, ¡hasta pronto!',
    pt: 'Sua assinatura foi pausada. Qualquer crédito que você possa ter será executado após o final desse período. Até breve!',
  },
  'An error has occurred while resuming the subscription.': {
    en: 'An error has occurred while resuming the subscription.',
    es: 'Ocurrió un error al reanudar la suscripción.',
    pt: 'Ocorreu um erro ao reativar sua assinatura.',
  },
  'Subscription resumed': {
    en: 'Subscription resumed',
    es: 'Suscripción reanudada',
    pt: 'Assinatura retomada',
  },
  'Your subscription has been resumed. Continue to enjoy all the content of your plan.': {
    en: 'Your subscription has been resumed. Continue to enjoy all the content of your plan.',
    es: 'Tu suscripción se ha reanudado. Sigue disfrutando de todo el contenido de tu plan.',
    pt: 'Sua assinatura foi retomada. Continue aproveitando todo o conteúdo de seu plano.',
  },
  'Successful plan change': {
    en: 'Successful plan change',
    es: 'Cambio de plan exitoso',
    pt: 'Alteracao de plano realizada com sucesso',
  },
  'Your plan has been changed': {
    en: 'Your plan has been updated successfully. Enjoy your new plan.',
    es: 'Tu plan se actualizó con éxito. Disfruta tu nuevo plan.',
    pt: 'Seu plano foi atualizado com sucesso. Aproveite seu novo plano.',
  },
  "It's not necessary to cancel this plan since it’s a one-time payment and doesn’t generate additional charges in the future.": {
    en: "It's not necessary to cancel this plan since it’s a one-time payment and doesn’t generate additional charges in the future.",
    es: 'No es necesario cancelar este plan, ya que es un pago único y no generará cargos adicionales en el futuro.',
    pt: 'Não é necessário cancelar esse plano, pois se trata de um pagamento único e não gera cobranças adicionais no futuro.',
  },
  'Resume subscription': {
    en: 'Resume subscription',
    es: 'Reanudar suscripción',
    pt: 'Reativa a sua assinatura'
  },
  'Accept': {
    en: 'Accept',
    es: 'Aceptar',
    pt: 'Aceitar'
  },
  'Plan details': {
    en: 'Plan details',
    es: 'Detalles del plan',
    pt: 'Detalhes do plano'
  },
  'There was an error creating subscription, please try again later': {
    en: 'There was an error creating your subscription, please try again later',
    es: 'Ocurrió un error al crear la suscripción, por favor intenta de nuevo mas tarde',
    pt: 'Ocorreu um erro ao criar a assinatura, tente novamente mais tarde',
  },
  'Reactivate subscription': {
    en: 'Reactivate subscription',
    es: 'Reactivar suscripción',
    pt: 'Reativar assinatura',
  },
  'Yes, reactivate subscription': {
    en: 'Yes, reactivate subscription',
    es: 'Si, reactivar suscripción',
    pt: 'Sim, reativar assinatura',
  },
  'Your subscription has been reactivated': {
    en: 'Your subscription has been reactivated',
    es: 'Tu suscripción ha sido reactivada',
    pt: 'Sua assinatura foi reativada',
  },
  'Continue enjoying all the content included in your plan': {
    en: 'Continue enjoying all the content included in your plan',
    es: 'Sigue disfrutando de todos los contenidos incluidos en tu plan',
    pt: 'Continue aproveitando todo o conteúdo incluído em seu plano',
  },
  'Your discount has been applied': {
    en: 'Your discount has been applied',
    es: '¡Tu descuento fue aplicado!',
    pt: 'Seu desconto foi aplicado!'
  },
  'Enjoy your gift! The discount will be reflected in your next charge': {
    en: 'Enjoy your gift! The discount will be reflected in your next charge',
    es: '¡Disfruta tu regalo! El descuento se verá reflejado en tu próximo cobro',
    pt: 'Aproveite seu presente! O desconto será refletido na sua próxima cobrança'
  },
  'Your subscription has been cancelled': {
    en: 'Your subscription has been cancelled',
    es: 'Tu suscripción ha sido cancelada',
    pt: 'Sua assinatura foi cancelada',
  },
  'Expires on': {
    en: 'Expires on',
    es: 'Expira el',
    pt: 'Vencimento em'
  },
  'Currently you don’t have a selected plan': {
    en: 'Currently you don’t have a selected plan',
    es: 'Actualmente no tienes un plan seleccionado',
    pt: 'Atualmente você não tem um plano selecionado'
  },
  'Select a plan to enjoy all live content.': {
    en: 'Select a plan to enjoy all live content.',
    es: 'Selecciona un plan para disfrutar de todos los contenidos en vivo.',
    pt: 'Selecione um plano para aproveitar todo o conteúdo ao vivo.'
  },
  'Select the new plan you wish to change to': {
    en: 'Select the new plan you wish to change to',
    es: 'Selecciona el nuevo plan al que te deseas cambiar',
    pt: 'Selecione o novo plano para o qual você deseja mudar'
  },
  'monthly': {
    en: 'monthly',
    es: 'mensual',
    pt: 'mensal'
  },
  'annual': {
    en: 'annual',
    es: 'anual',
    pt: 'anual'
  },
  'weekly': {
    en: 'weekly',
    es: 'semanal',
    pt: 'semanal'
  },
  'daily': {
    en: 'daily',
    es: 'diario',
    pt: 'diário'
  },
  'Your new plan': {
    en: 'You new plan',
    es: 'Tu plan nuevo',
    pt: 'Seu novo plano'
  },
  'Your current plan': {
    en: 'Your current plan',
    es: 'Tu plan actual',
    pt: 'Seu plano atual'
  },
  'New plan': {
    en: 'New plan',
    es: 'Plan nuevo',
    pt: 'Novo plano'
  },
  'Will change to': {
    en: 'Will change to',
    es: 'Cambiará a',
    pt: 'Será alterado para'
  },
  'There is no plan selected': {
    en: 'There is no plan selected',
    es: 'No hay ningún plan seleccionado',
    pt: 'Não há um plano selecionado'
  },
  'There are no plans available': {
    en: 'There are no plans available',
    es: 'No hay planes disponibles',
    pt: 'Não há planos disponíveis'
  },
  'Only option available': {
    en: 'Only option available',
    es: 'Única opción disponible',
    pt: 'Única opção disponível'
  },
  'month': {
    original: 'month',
    es: 'mes',
    pt: 'mês'
  },
  'year': {
    original: 'year',
    es: 'año',
    pt: 'ano'
  },
  'Before': {
    en: 'Before',
    es: 'Antes',
    pt: 'Antes'
  },
  'Now': {
    en: 'Now',
    es: 'Ahora',
    pt: 'Agora'
  },
  'Your payment method has been updated successfully': {
    en: 'Your payment method has been updated successfully',
    es: 'Tu método de pago ha sido actualizado exitosamente',
    pt: 'Seu método de pagamento foi atualizado com sucesso'
  },
  'Leave without saving?': {
    en: 'Leave without saving?',
    es: '¿Salir sin guardar?',
    pt: 'Sair sem salvar?'
  },
  'Leave without saving': {
    en: 'Leave without saving',
    es: 'Salir sin guardar',
    pt: 'Sair sem salvar'
  },
  'Save the changes before leaving the site to apply your selection': {
    en: 'Save the changes before leaving the site to apply your selection',
    es: 'Guarda los cambios antes de abandonar el sitio para aplicar tu selección',
    pt: 'Salve as alterações antes de sair do site para aplicar sua seleção'
  },
  'Your promotional code has been added': {
    en: 'Your promotional code has been added',
    es: 'Tu código promocional ha sido añadido.',
    pt: 'Seu código promocional foi adicionado'
  },
  'You have currently {orders} plan': {
    en: 'You have currently {orders} plan',
    es: 'Actualmente tienes {orders} plan',
    pt: 'Atualmente, você tem {orders} plano'
  },
  'You have currently {orders} plans': {
    en: 'You have currently {orders} plans',
    es: 'Actualmente tienes {orders} planes',
    pt: 'Atualmente, você tem {orders} planos'
  },
  'The change will take effect immediately': {
    en: 'The change will take effect immediately',
    es: 'El cambio tendrá efecto de inmediato',
    pt: 'A alteração entrará em vigor imediatamente',
  },
  'You will make the following plan change:': {
    en: 'You will make the following plan change:',
    es: 'Realizarás el siguiente cambio de plan:',
    pt: 'Você fará a seguinte alteração de plano:'
  },
  'Confirm change plan': {
    en: 'Confirm change plan',
    es: 'Confirmar cambio de plan',
    pt: 'Confirmar alteração de plano'
  },
  'View plan change details': {
    en: 'View plan change details',
    es: 'Ver detalles del cambio de plan',
    pt: 'Ver detalhes da alteração de plano'
  },
  'Total to pay': {
    en: 'Total to pay',
    es: 'Total a pagar',
    pt: 'Total a pagar'
  },
  'Any applicable credit will be determined based on your current billing rate and subscription usage, and will be applied to your next invoice.': {
    en: 'Any applicable credit will be determined based on your current billing rate and subscription usage, and will be applied to your next invoice.',
    es: 'Cualquier crédito aplicable se determinará según tu tarifa de facturación actual y el uso consumido de tu suscripción, y se aplicará a tu próxima factura.',
    pt: 'Qualquer crédito aplicável será determinado com base na sua tarifa de faturamento atual e no uso consumido da sua assinatura, e será aplicado à sua próxima fatura.'
  },
  'Any applicable charge will be calculated based on your current billing rate and subscription usage.': {
    en: 'Any applicable charge will be calculated based on your current billing rate and subscription usage.',
    es: 'Cualquier cargo aplicable se calculará según tu tarifa de facturación actual y el uso consumido de tu suscripción.',
    pt: 'Qualquer cobrança aplicável será calculada com base na sua tarifa de faturamento atual e no uso consumido da sua assinatura.'
  },
  'Update payment method': {
    en: 'Update payment method',
    es: 'Actualizar método de pago',
    pt: 'Atualizar método de pagamento'
  },
  'Add payment method': {
    en: 'Add payment method',
    es: 'Agregar método de pago',
    pt: 'Adicionar método de pagamento'
  },
  'Add': {
    en: 'Add',
    es: 'Agregar',
    pt: 'Adicionar'
  },
  'No payment method': {
    en: 'No payment method',
    es: 'Sin método de pago',
    pt: 'Sem método de pagamento'
  },
  "We couldn't load the payment form. Please refresh the page and try again.": {
    en: "We couldn't load the payment form. Please refresh the page and try again.",
    es: "No pudimos cargar el formulario de pago. Recarga la página e inténtalo de nuevo.",
    pt: "Não conseguimos carregar o formulário de pagamento. Recarregue a página e tente novamente."
  },
  'If your payment is several days past due, we recommend canceling your plan and subscribing again.': {
    en: 'If your payment is several days past due, we recommend canceling your plan and subscribing again.',
    es: 'Si tu pago lleva varios días de retraso, te recomendamos que canceles tu plan y vuelvas a suscribirte.',
    pt: 'Se o seu pagamento estiver atrasado há vários dias, recomendamos cancelar o seu plano e assinar novamente.'
  },
  'Your cancellation takes effect immediately. There is no reactivation, but you can subscribe again whenever you want.': {
    en: 'Your cancellation takes effect immediately. There is no reactivation, but you can subscribe again whenever you want.',
    es: 'Tu cancelación se aplica de inmediato. No hay reactivación, pero puedes volver a suscribirte cuando quieras.',
    pt: 'Seu cancelamento entra em vigor imediatamente. Não há reativação, mas você pode assinar novamente quando quiser.'
  },
  'Your payment method has been saved': {
    en: 'Your payment method has been saved',
    es: 'Tu método de pago ha sido guardado',
    pt: 'Seu meio de pagamento foi salvo'
  },
  'Your access will be restored once the pending payment goes through.': {
    en: 'Your access will be restored once the pending payment goes through.',
    es: 'Tu acceso se restablecerá cuando se procese el pago pendiente.',
    pt: 'Seu acesso será restabelecido assim que o pagamento pendente for processado.'
  },
  'There was a problem with your subscription payment.': {
    en: 'There was a problem with your subscription payment.',
    es: 'Hubo un problema con el pago de tu suscripción.',
    pt: 'Houve um problema com o pagamento da sua assinatura.'
  },
  'Back to profile': {
    en: 'Back to profile',
    es: 'Volver al perfil',
    pt: 'Voltar ao perfil'
  },
  'To manage your subscription, you must do it through your provider.': {
    en: 'To manage your subscription, you must do it through your provider.',
    es: 'Para gestionar tu suscripción, debes hacerlo a través de tu proveedor.',
    pt: 'Para gerenciar sua assinatura, você deve fazê-lo através de seu provedor.'
  },
  'Your email address is linked to your account\nand can’t be changed': {
    en: 'Your email address is linked to your account\nand can’t be changed',
    es: 'Tu dirección de correo electrónico está vinculada\na tu cuenta y no se puede cambiar',
    pt: 'Seu endereço de e-mail está vinculado à\nsua conta e não pode ser alterado'
  },
  'These fields allow you to edit your payment method. If you need to update your billing information (name, address, etc.) please contact support.': {
    en: 'These fields allow you to edit your payment method. If you need to update your billing information (name, address, etc.) please contact support.',
    es: 'Estos campos te permiten editar tu método de pago. Si necesitas actualizar tu información de facturación (nombre, dirección, etc.) por favor contacta con soporte.',
    pt: 'Estes campos permitem editar seu método de pagamento. Se você precisar atualizar suas informações de cobrança (nome, endereço, etc.) entre em contato com o suporte.'
  },
  'What do you need to edit?': {
    en: 'What do you need to edit?',
    es: '¿Qué necesitas editar?',
    pt: 'O que você precisa editar?'
  },
  'Edit card details': {
    en: 'Edit card details',
    es: 'Editar datos de tarjeta',
    pt: 'Editar dados do cartão'
  },
  'Edit billing information': {
    en: 'Edit billing information',
    es: 'Editar datos de facturación',
    pt: 'Editar dados de cobrança'
  },
  'If you need to edit billing information (name, address, country, postal code), please contact support.': {
    en: 'If you need to edit billing information (name, address, country, postal code), please contact support.',
    es: 'Si necesitas editar datos de facturación (nombre, dirección, país, código postal), debes contactar con soporte.',
    pt: 'Se você precisar editar os dados de cobrança (nome, endereço, país, código postal), entre em contato com o suporte.'
  },
  'Billing information': {
    en: 'Billing information',
    es: 'Información de facturación',
    pt: 'Informações de cobrança'
  },
  'Feedback': {
    en: 'Feedback',
    es: 'Comentarios',
    pt: 'Comentários'
  },
  'Rate us': {
    en: 'Rate us',
    es: 'Califícanos',
    pt: 'Avalie-nos'
  },
  'How would you rate your experience?': {
    en: 'How would you rate your experience?',
    es: '¿Cómo calificarías tu experiencia?',
    pt: 'Como você avaliaria sua experiência?'
  },
  'Your opinion is important to us and helps us improve our service': {
    en: 'Your opinion is important to us and helps us improve our service',
    es: 'Tu opinión es importante para nosotros y nos ayuda a mejorar nuestro servicio',
    pt: 'Sua opinião é importante para nós e nos ajuda a melhorar nosso serviço'
  },
  'What could we improve? (Select multiple)': {
    en: 'What could we improve? (Select multiple)',
    es: '¿Qué podríamos mejorar? (Selecciona varias)',
    pt: 'O que poderíamos melhorar? (Selecione várias)'
  },
  'Lack of content': {
    en: 'Lack of content',
    es: 'Falta de contenido',
    pt: 'Falta de conteúdo'
  },
  'Lack of features': {
    en: 'Lack of features',
    es: 'Falta de funciones',
    pt: 'Falta de recursos'
  },
  'Stream cuts off': {
    en: 'Stream cuts off',
    es: 'Cortes en la transmisión',
    pt: 'Cortes na transmissão'
  },
  'Low quality': {
    en: 'Low quality',
    es: 'Baja calidad',
    pt: 'Baixa qualidade'
  },
  'Difficulty finding matches': {
    en: 'Difficulty finding matches',
    es: 'Dificultad para encontrar partidos',
    pt: 'Dificuldade para encontrar partidas'
  },
  'Payment issues': {
    en: 'Payment issues',
    es: 'Problemas de pago',
    pt: 'Problemas de pagamento'
  },
  'Missing leagues or tournaments': {
    en: 'Missing leagues or tournaments',
    es: 'Falta de ligas o torneos',
    pt: 'Falta de ligas ou torneios'
  },
  'Other': {
    en: 'Other',
    es: 'Otro',
    pt: 'Outro'
  },
  'Send feedback': {
    en: 'Send feedback',
    es: 'Enviar comentarios',
    pt: 'Enviar feedback'
  },
  'Thanks for your feedback!': {
    en: 'Thanks for your feedback!',
    es: '¡Gracias por tus comentarios!',
    pt: 'Obrigado pelo seu feedback!'
  },
  'We appreciate you taking the time to help us improve. Your feedback has been received and will be used to enhance our service. If you want to rate us on your app store, please click the button below.': {
    en: 'We appreciate you taking the time to help us improve. Your feedback has been received and will be used to enhance our service. If you want to rate us on your app store, please click the button below.',
    es: 'Agradecemos que te hayas tomado el tiempo para ayudarnos a mejorar. Hemos recibido tus comentarios y se utilizarán para mejorar nuestro servicio. Si deseas calificarnos en tu tienda de aplicaciones, haz clic en el botón a continuación.',
    pt: 'Agradecemos por dedicar seu tempo para nos ajudar a melhorar. Seu feedback foi recebido e será usado para aprimorar nosso serviço. Se você quiser nos avaliar na sua loja de aplicativos, clique no botão abaixo.'
  },
  'No, thanks': {
    en: 'No, thanks',
    es: 'No, gracias',
    pt: 'Não, obrigado'
  },
  'Yes, I want to help': {
    en: 'Yes, I want to help',
    es: 'Sí, quiero ayudar',
    pt: 'Sim, eu quero ajudar'
  },
  "We couldn't process your last payment, please update your payment method to continue with your subscription": {
    en: "We couldn't process your last payment, please update your payment method to continue with your subscription",
    es: "No pudimos procesar tu último pago, por favor actualiza tu método de pago para continuar con tu suscripción",
    pt: "Não conseguimos processar seu último pagamento, por favor atualize seu método de pagamento para continuar com sua assinatura"
  },
  "We couldn't process your last payment. Please update your payment method in your App Store account to continue with your subscription.": {
    en: "We couldn't process your last payment. Please update your payment method in your App Store account to continue with your subscription.",
    es: "No pudimos procesar tu último pago. Actualiza tu método de pago en tu cuenta de App Store para continuar con tu suscripción.",
    pt: "Não conseguimos processar seu último pagamento. Atualize seu método de pagamento na sua conta da App Store para continuar com sua assinatura."
  },
  "We couldn't process your last payment. Please update your payment method in your Google Play account to continue with your subscription.": {
    en: "We couldn't process your last payment. Please update your payment method in your Google Play account to continue with your subscription.",
    es: "No pudimos procesar tu último pago. Actualiza tu método de pago en tu cuenta de Google Play para continuar con tu suscripción.",
    pt: "Não conseguimos processar seu último pagamento. Atualize seu método de pagamento na sua conta do Google Play para continuar com sua assinatura."
  },
  "We couldn't process your last payment. Please update your payment method in your Roku account to continue with your subscription.": {
    en: "We couldn't process your last payment. Please update your payment method in your Roku account to continue with your subscription.",
    es: "No pudimos procesar tu último pago. Actualiza tu método de pago en tu cuenta de Roku para continuar con tu suscripción.",
    pt: "Não conseguimos processar seu último pagamento. Atualize seu método de pagamento na sua conta da Roku para continuar com sua assinatura."
  },
  "We couldn't process your last payment. Please update your payment method with your provider to continue with your subscription.": {
    en: "We couldn't process your last payment. Please update your payment method with your provider to continue with your subscription.",
    es: "No pudimos procesar tu último pago. Actualiza tu método de pago con tu proveedor para continuar con tu suscripción.",
    pt: "Não conseguimos processar seu último pagamento. Atualize seu método de pagamento com seu provedor para continuar com sua assinatura."
  },
  'Update in {provider}': {
    en: 'Update in {provider}',
    es: 'Actualizar en {provider}',
    pt: 'Atualizar em {provider}'
  },
  'You have past due orders, please update your payment method to continue enjoying all the content': {
    en: 'You have past due orders, please update your payment method to continue enjoying all the content',
    es: 'Tienes órdenes vencidas, por favor actualiza tu método de pago para continuar disfrutando de todo el contenido',
    pt: 'Você tem pedidos vencidos, por favor atualize seu método de pagamento para continuar aproveitando todo o conteúdo'
  },
  'Provider': {
    en: 'Provider',
    es: 'Proveedor',
    pt: 'Provedor'
  },
  'Expires in {expires} day': {
    en: 'Expires in {expires} day',
    es: 'Vence en {expires} día',
    pt: 'Expira em {expires} dia'
  },
  'Expires in {expires} days': {
    en: 'Expires in {expires} days',
    es: 'Vence en {expires} días',
    pt: 'Expira em {expires} dias'
  },
  'Reactivate account': {
    en: 'Reactivate account',
    es: 'Reactivar cuenta',
    pt: 'Reativar conta'
  },
  'Your account will be deleted within a period of 30 days from when you started the process.': {
    en: 'Your account will be deleted within a period of 30 days from when you started the process.',
    es: 'Tu cuenta se eliminará en un plazo de 30 días desde que iniciaste el proceso.',
    pt: 'Sua conta será excluída em um prazo de 30 dias a partir do início do processo.'
  },
  'The account will be deleted after a period of 30 days. Do you want to continue?': {
    en: 'The account will be deleted after a period of 30 days. Do you want to continue?',
    es: 'La cuenta se eliminará después de un plazo de 30 días. ¿Deseas continuar?',
    pt: 'A conta será excluída após um prazo de 30 dias. Deseja continuar?'
  },
  'The deletion process will be canceled and you can continue using your account normally': {
    en: 'The deletion process will be canceled and you can continue using your account normally',
    es: 'El proceso de eliminación se cancelará y podrás seguir usando tu cuenta normalmente',
    pt: 'O processo de exclusão será cancelado e você poderá continuar usando sua conta normalmente'
  },
  'Are you sure you want to see scores for all matches?': {
    en: 'Are you sure you want to see scores for all matches?',
    es: '¿Estás seguro de que quieres ver los resultados de todos los partidos?',
    pt: 'Tem certeza de que deseja ver os resultados de todas as partidas?'
  },
  'Pause subscription for 60 days': {
    en: 'Pause subscription for 60 days',
    es: 'Pausar la suscripción por 60 días',
    pt: 'Pausar a assinatura por 60 dias'
  },
  "Pause your subscription for 60 days. You won't be charged while your subscription is paused. You can resume your service at any time. You can only pause your account once.": {
    en: "Pause your subscription for 60 days. You won't be charged while your subscription is paused. You can resume your service at any time. You can only pause your account once.",
    es: 'Pausa tu suscripción por 60 días. No se te cobrará mientras tu suscripción esté pausada. Puedes reanudar tu servicio en cualquier momento. Solo puedes pausar tu cuenta una vez.',
    pt: 'Pause sua assinatura por 60 dias. Você não será cobrado enquanto sua assinatura estiver pausada. Você pode retomar seu serviço a qualquer momento. Você só pode pausar sua conta uma vez.'
  },
  'Resume your subscription': {
    en: 'Resume your subscription',
    es: 'Reanudar tu suscripción',
    pt: 'Retomar sua assinatura'
  },
  'Are you sure you want to resume your subscription?': {
    en: 'Are you sure you want to resume your subscription?',
    es: '¿Estás seguro de que quieres reanudar tu suscripción?',
    pt: 'Tem certeza de que deseja retomar sua assinatura?'
  },
  'Reactivate your subscription': {
    en: 'Reactivate your subscription',
    es: 'Reactivar tu suscripción',
    pt: 'Reativar sua assinatura'
  },
  'You will reactivate your subscription and all the content of your plan will be available again, do you wish to continue?': {
    en: 'You will reactivate your subscription and all the content of your plan will be available again, do you wish to continue?',
    es: 'Reactivarás tu suscripción y todo el contenido de tu plan estará disponible nuevamente, ¿deseas continuar?',
    pt: 'Você reativará sua assinatura e todo o conteúdo do seu plano estará disponível novamente, deseja continuar?'
  },
  'Go to pay': {
    en: 'Go to pay',
    es: 'Ir a pagar',
    pt: 'Ir para o pagamento'
  },
  'Your password has been changed successfully': {
    en: 'Your password has been changed successfully',
    es: 'Tu contraseña se ha cambiado correctamente',
    pt: 'Sua senha foi alterada com sucesso'
  },
  'Your changes have been successfully updated': {
    en: 'Your changes have been successfully updated',
    es: 'Tus cambios se han actualizado correctamente',
    pt: 'Suas alterações foram atualizadas com sucesso'
  },
  'There was an error saving your changes. Please try again': {
    en: 'There was an error saving your changes. Please try again',
    es: 'Ocurrió un error al guardar tus cambios. Por favor, inténtalo de nuevo',
    pt: 'Ocorreu um erro ao salvar suas alterações. Por favor, tente novamente'
  },
  'There was an error validating your request.': {
    en: 'There was an error validating your request.',
    es: 'Ocurrió un error al validar tu solicitud.',
    pt: 'Ocorreu um erro ao validar sua solicitação.'
  },
  'Tell us more...': {
    en: 'Tell us more...',
    es: 'Cuéntanos más...',
    pt: 'Conte-nos mais...'
  }
}

export default translations